import * as types from "../mutation-types";
import router from "src/config/routes";

const state = {
  tabs: [],
  comps: [],
  dashboardActive: true,
  viewNames: {
    entry: "entry",
    distribution: "distribution",
    review: "review",
    project: "project",
    businessarea: "businessarea",
    except: "except",
    schedule: "schedule",
    contract: "contract",
    receipt: "receipt",
    plan: "plan",
    cityPlan: "planlookCity",
    planDispatch: "planDispatch",
    transportPlan: "transportPlan",
    autoLinePlan: "autoLinePlan",
    activityTracking: "activityTracking",
    setup: "setup",
    track: "track",
    roads: "roads",
    orders: "orders",
    number: "number",
    synchronousQuery: "synchronousQuery",
    deviceManage: "deviceManage",
    perform: "perform",
    our: "our",
    machine: "machine",
    account: "account",
    forexcept: "forexcept",
    forereceipt: "forereceipt",
    foreaccount: "foreaccount",
    forentry: "forentry",
    forecheck: "forecheck",
    forelook: "forelook",
    foreability: "foreability",
    foreour: "foreour",
    foreproject: "foreproject",
    transferDelivery: "transferDelivery",
    sendGoods: "sendGoods",
    billingConfirm: "billingConfirm",
    accountsReceivable: "accountsReceivable",
    reconciliation: "reconciliation",
    billConfirm: "billConfirm",
    billPayable: "billPayable",
    billReconciliation: "billReconciliation",
    dynamicReport: "dynamicReport",
    dynamicReportInfo: "dynamicReportInfo",
    billQueryConfirm: "billQueryConfirm",
    billQueryPayable: "billQueryPayable",
    billQueryReconciliation: "billQueryReconciliation",
  },
};

const getters = {
  dashboardActive: (state) => state.dashboardActive,
  allTabs: (state) => state.tabs,
  allComps: (state) => state.comps,
  entryViewName: (state) => state.viewNames.entry,
  distributionViewName: (state) => state.viewNames.distribution,
  reviewViewName: (state) => state.viewNames.review,
  accountViewName: (state) => state.viewNames.account,
  projectViewName: (state) => state.viewNames.project,
  prductViewName: (state) => state.viewNames.prduct,
  businessareaViewName: (state) => state.viewNames.businessarea,
  exceptViewName: (state) => state.viewNames.except,
  scheduleViewName: (state) => state.viewNames.schedule,
  receiptViewName: (state) => state.viewNames.receipt,
  planViewName: (state) => state.viewNames.plan,
  cityPlanViewName: (state) => state.viewNames.cityPlan,
  autoLinePlanViewName: (state) => state.viewNames.autoLinePlan,
  setupViewName: (state) => state.viewNames.setup,
  abilityViewName: (state) => state.viewNames.ability,
  trackViewName: (state) => state.viewNames.track,
  roadsViewName: (state) => state.viewNames.roads,
  ordersViewName: (state) => state.viewNames.orders,
  numberViewName: (state) => state.viewNames.number,
  synchronousQueryViewName: (state) => state.viewNames.synchronousQuery,
  deviceManageViewName: (state) => state.viewNames.deviceManage,
  performViewName: (state) => state.viewNames.perform,
  messageViewName: (state) => state.viewNames.message,
  accountViewName: (state) => state.viewNames.account,
  permissionViewName: (state) => state.viewNames.permission,
  machineViewName: (state) => state.viewNames.machine,
  forexceptViewName: (state) => state.viewNames.forexcept,
  forereceiptViewName: (state) => state.viewNames.forereceipt,
  foreaccountViewName: (state) => state.viewNames.foreaccount,
  forentryViewName: (state) => state.viewNames.forentry,
  forelookViewName: (state) => state.viewNames.forelook,
  forecheckViewName: (state) => state.viewNames.forecheck,
  foreabilityViewName: (state) => state.viewNames.foreability,
  planDispatchViewName: (state) => state.viewNames.planDispatch,
  transportPlanViewName: (state) => state.viewNames.transportPlan,
  transferDeliveryViewName: (state) => state.viewNames.transferDelivery,
  sendGoodsViewName: (state) => state.viewNames.sendGoods,
  billingConfirmViewName: (state) => state.viewNames.billingConfirm,
  accountsReceivableViewName: (state) => state.viewNames.accountsReceivable,
  reconciliationViewName: (state) => state.viewNames.reconciliation,
  billPayableViewName: (state) => state.viewNames.billPayable,
  billConfirmViewName: (state) => state.viewNames.billConfirm,
  billReconciliationViewName: (state) => state.viewNames.billReconciliation,
  dynamicReportViewName: (state) => state.viewNames.dynamicReport,
  dynamicReportInfoViewName: (state) => state.viewNames.dynamicReportInfo,
  billQueryPayableViewName: (state) => state.viewNames.billQueryPayable,
  billQueryConfirmViewName: (state) => state.viewNames.billQueryConfirm,
  billQueryReconciliationViewName: (state) =>
    state.viewNames.billQueryReconciliation,
};

const actions = {
  addToTab({ commit }, tab) {
    commit(types.ADD_TO_TAB, tab);
  },
  removeFromTab({ commit }, tab) {
    commit(types.REMOVE_FROM_TAB, tab);
  },
  setDashboardActive({ commit }) {
    commit(types.SET_DASHBOARD_ACTIVE);
  },
  setTabActive({ commit }, tab) {
    commit(types.SET_TAB_ACTIVE, tab);
  },
  setTabViewName({ commit }, [bizName, viewName]) {
    commit(types.SET_TAB_VIEW_NAME, [bizName, viewName]);
  },
  setTabLabel({ commit }, [tabName, label]) {
    commit(types.SET_TAB_LABEL, [tabName, label]);
  },
  setTabRefresh({ commit }, tab) {
    commit(types.SET_TAB_REFRESH, tab);
  },
};

const mutations = {
  [types.ADD_TO_TAB](state, tab) {
    // Dashboard is a static tab, prevent add and remove
    if (tab.name == "dashboard") {
      return;
    }
    let t = state.tabs.find((tempTab) => {
      return tempTab.name == tab.name;
    });
    // Add if not exists
    if (!t) {
      state.tabs.push(tab);

      // Refresh component by set keepInBackground = true;
      let comp = state.comps.find((comp) => {
        return comp.name == tab.name;
      });
      if (!comp) {
        tab.keepInBackground = true;
        state.comps.push(tab);
      } else {
        comp.keepInBackground = true;
      }
    } else {
      if (t.label !== tab.label) {
        t.label = tab.label;
      }
    }
  },
  [types.REMOVE_FROM_TAB](state, tab) {
    if (tab.name == "dashboard") {
      return;
    }

    // Destroy the component
    let comp = state.comps.find((comp) => {
      return comp.name == tab.name;
    });
    if (comp) {
      comp.keepInBackground = false;
    }
    // state.tabs.find((comp) => {
    //   if(comp.name == tab.name){
    //       state.tabs.splice(state.tabs.indexOf(comp), 1);
    //       state.dashboardActive = true;
    //   }
    // })
    state.tabs.forEach((comp) => {
      if (comp.name == tab.name) {
        state.tabs.splice(state.tabs.indexOf(comp), 1);
      }
    });
  },
  [types.SET_DASHBOARD_ACTIVE](state) {
    state.tabs.forEach(function (tabTemp) {
      tabTemp.isActive = false;
    });
    state.dashboardActive = true;
  },
  [types.SET_TAB_ACTIVE](state, tab) {
    state.dashboardActive = false;
    state.tabs.forEach((item) => {
      if (item.name == tab.name) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
    });
    state.comps.forEach((item) => {
      if (item.name == tab.name) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
    });
  },
  [types.SET_TAB_VIEW_NAME](state, [bizName, viewName]) {
    state.viewNames[bizName] = viewName;
  },
  [types.SET_TAB_LABEL](state, [tabName, label]) {
    let t = state.tabs.find((tempTab) => {
      return tempTab.name == tabName;
    });
    if (t) {
      t.label = label;
    }
  },
  [types.SET_TAB_REFRESH](state, tab) {
    state.comps.map((tempTab, index) => {
      if (tempTab.name == tab.name) {
        tempTab.needRefresh = tab.needRefresh;
      }
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js